<template>
  <div class="dialog_box">
    <el-dialog title="工单详情" :visible="show" width="997px" @close="dialogClose" top="10vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <div class="module_box">
          <div class="form_title">基本信息</div>
          <el-descriptions class="margin-top" :column="2" border label-class-name="my-label"
            content-class-name="my-content">
            <el-descriptions-item label="工单编号">
              <div>{{ detailData.id }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="工单类型">
              <div>{{ detailData.orderTypeDesc }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="企业名称">
              <div>{{ detailData.orgName }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="地址验证">
              <div>{{ detailData.addr }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="联系人">
              <div>{{ detailData.contactsName }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="联系方式">
              <div>{{ detailData.contactsPhone }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="联系邮箱">
              <div>{{ detailData.contactsEmail }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="创建人">
              <div>{{ detailData.createUser }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="期望上门/处理时间">
              <div>{{ detailData.orderExpectDoorTime }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <div>{{ detailData.orderRemark }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="所属区域">
              <div>{{ detailData.addr }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="申请时间">
              <div>{{ detailData.createTime }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="详细地址">
              <div>{{ detailData.addrDetail }}</div>
            </el-descriptions-item>
          </el-descriptions>

          <div class="form_title" style="margin-top: 20px">
            {{ (detailData.orderType == 0 || detailData.orderType == 1) ? "安装/维护车辆信息" : "网点信息" }}
          </div>
          <el-descriptions class="margin-top" :column="2" border label-class-name="my-label"
            content-class-name="my-content">
            <el-descriptions-item label="车牌号码">
              <div>{{ detailData.carNumber }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="车辆数量">
              <div>{{ detailData.carNum }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="通道数量">
              <div>
                {{
                  (detailData.orderType == 0 || detailData.orderType == 1) ? detailData.carCameraNum :
                  detailData.netCameraNum
                }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="设备品牌">
              <div>
                {{
                  (detailData.orderType == 0 || detailData.orderType == 1) ? detailData.carCameraBrand :
                  detailData.netCameraBrand
                }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="设备序列号">
              <div>{{ detailData.carSerialNumber }}</div>
            </el-descriptions-item>
            <el-descriptions-item> </el-descriptions-item>
          </el-descriptions>

          <div class="form_title" style="margin-top: 20px">流转信息</div>
          <div class="moving_box" v-for="(i, idx) in movingList" :key="idx">
            <div class="moving_left">
              <div class="line_top"></div>
              <img class="yuanquan" src="../../../../static/images/yuanquan.svg" alt="" />
              <div class="line_bottom"></div>
            </div>
            <div class="moving_right">
              <div class="moving_right_top">
                <div class="moving_title">{{ i.operateType }}</div>
                <div class="moving_date">{{ i.operTime }}</div>
                <div class="moving_text">{{ i.logResult }}</div>
              </div>
              <div v-if="i.fileList != null && i.fileList.length > 0" class="moving_image">
                <div v-for="(j, jdx) in i.fileList" :key="jdx" :class="['image_box', j.fileName ? '' : 'image_box_1']">
                  <el-image style="width: 160px; height: 120px" :src="j.filePath"
                    :preview-src-list="[j.filePath]"></el-image>
                  <div class="file_name" v-if="j.fileName">{{ j.fileName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn_ok" @click="dialogClose">确 认</el-button>
        <!-- <el-button class="btn btn_ok" @click="confirm">提 交</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      movingList: [],
      detailData: {}
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.$http.queryWorkOrderProcess({ orderId: this.data.orderId }).then(res => {
          if (res.code === 0) {
            this.movingList = res.data
          } else {
            this.movingList = [];
            this.$message.error(res.msg)
          }
        })
        this.$http.jumpToWorkOrderById({ orderId: this.data.orderId }).then(res => {
          if (res.code === 0) {
            this.detailData = res.data
          } else {
            this.detailData = {};
            this.$message.error(res.msg)
          }
        })
      }
    }
  },
  created () { },
  methods: {
    dialogClose () {
      this.$emit("update:show", false);
    },
    confirm (formName) { },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.my-label {
  background-color: #ecf5ff !important;
  width: 140px;
  height: 30px;
  text-align: center !important;
}

/deep/.my-content {
  width: 310px;
  height: 30px;
  text-align: center !important;
}

/deep/.el-descriptions .is-bordered .el-descriptions-item__cell {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/messagePage/component/detail.vue